import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { UtilsService } from 'src/app/utils/utils.service';

@Component({
  selector: 'app-source-toggle',
  templateUrl: './source-toggle.component.html',
  styleUrls: ['./source-toggle.component.scss']
})
export class SourceToggleComponent implements OnInit, OnDestroy {

  @Input() gisMapComp: any;

  selectedSource: string = '';
  // false = seamless Observed, true = seamless Forecast, null = not seamless
  seamlessIsObserved: boolean | null = null;
  private destroy: Subject<boolean> = new Subject<boolean>();

  constructor(private utils: UtilsService) {}

  ngOnInit() {
    this.utils.selectedParams
      .pipe(takeUntil(this.destroy))
      .subscribe((params: any) => {
        if (params && params['source']) {
          this.selectedSource = params['source'];
        }
      });

    this.utils.setSeamlessForecastChart
      .pipe(takeUntil(this.destroy))
      .subscribe((value: any) => {
        if (value === false) {
          this.seamlessIsObserved = false;
        } else if (value === true) {
          this.seamlessIsObserved = true;
        } else {
          this.seamlessIsObserved = null;
        }
      });
  }

  getSourceOptions(): string[] {
    const forecastLength = this.gisMapComp && this.gisMapComp.params && this.gisMapComp.params['forecastLength'];
    // Seamless: show only EUMETSAT when playbar is on Observed section
    if (forecastLength === 'seamless' && this.seamlessIsObserved === false) {
      return ['EUMETSAT'];
    }
    const byForecast = this.gisMapComp && this.gisMapComp.otherOptions && this.gisMapComp.otherOptions['sourceMappingByForecast'];
    if (byForecast) {
      return byForecast[forecastLength] || [];
    }
    return (this.gisMapComp && this.gisMapComp.sourceOptions) || [];
  }

  private getSourceMapping(): any {
    const byForecast = this.gisMapComp && this.gisMapComp.otherOptions && this.gisMapComp.otherOptions['sourceMappingByForecast'];
    if (byForecast) {
      return (this.gisMapComp.otherOptions && this.gisMapComp.otherOptions['sourceMapping']) || {};
    }
    return (this.gisMapComp && this.gisMapComp.sourcePillMapping) || {};
  }

  onSourcePillClick(displayLabel: string) {
    // Observed section has only EUMETSAT; no source switching needed
    if (this.seamlessIsObserved === false) return;
    // Do nothing if the clicked source is already active
    const sourceMapping = this.getSourceMapping();
    if (!sourceMapping) return;
    const apiValue = sourceMapping[displayLabel];
    if (!apiValue) return;
    if (apiValue === this.selectedSource) return;
    // Prevent concurrent source switches while a load is already in progress
    if (this.gisMapComp && this.gisMapComp.showThrobber) return;
    const options = { ...this.gisMapComp.params };
    options['source'] = apiValue;
    this.utils.setSelectedParams(options);
  }

  getActivePillLabel(): string {
    // Observed section always shows EUMETSAT as active
    if (this.seamlessIsObserved === false) return 'EUMETSAT';
    const sourceMapping = this.getSourceMapping();
    if (!sourceMapping || !this.selectedSource) return '';
    const direct = Object.keys(sourceMapping).find(k => sourceMapping[k] === this.selectedSource);
    if (direct) return direct;
    // MODIS_LST_NIGHT has no direct entry in sourceMapping (only MODIS_LST_DAY does);
    // treat all MODIS variants as the 'MODIS' pill
    if (this.selectedSource.startsWith('MODIS_LST')) {
      return Object.keys(sourceMapping).find(k => k === 'MODIS') || '';
    }
    return '';
  }

  ngOnDestroy() {
    this.destroy.next(true);
    this.destroy.complete();
  }

}
